import { render, staticRenderFns } from "./TemplatePane.vue?vue&type=template&id=676a4c78&scoped=true"
import script from "./TemplatePane.vue?vue&type=script&lang=js"
export * from "./TemplatePane.vue?vue&type=script&lang=js"
import style0 from "./TemplatePane.vue?vue&type=style&index=0&id=676a4c78&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676a4c78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676a4c78')) {
      api.createRecord('676a4c78', component.options)
    } else {
      api.reload('676a4c78', component.options)
    }
    module.hot.accept("./TemplatePane.vue?vue&type=template&id=676a4c78&scoped=true", function () {
      api.rerender('676a4c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/statusMonitoringAndWarning/cmp/TemplatePane.vue"
export default component.exports